/** @format */

import React, {
    useEffect,
    useState,
    useRef,
    useMemo
} from 'react';
import {
    SimpleImg
} from 'react-simple-img';
import {
    Icon,
    Popover
} from 'antd';
import {
    imgSuffix
} from '../../util/inspiration';
import './index.less';

export default (props) => {
    const {
        list,
        selectedIds,
        setSelectedIds,
        displayRender,
        onSelect,
        disabled,
        setShowBigImg,
        setImgUrl
    } = props;
    const refUl = useRef('');
    const [liContent, setLiContent] = useState([]);

    useEffect(() => {
        if (list.length > 0) {
            waterFallInit();
        } else {
            setLiContent([]);
        }

        if (list.length > 0)
            refUl.current.scrollTop = 0;
    }, [list]);

    const cellWidth = useMemo(() => {
        const ul = refUl.current;
        const clientWidth = ul.clientWidth;
        const result = Math.floor((clientWidth / 6) - 10)
        return result < 0 ? 244 : result;
    }, [refUl.current]);

    const waterFallInit = () => {
        const liHeightList = new Array(6).fill(0);
        const liContentList = new Array();
        for (let i = 0; i < 6; i++) {
            liContentList.push(new Array());
        }
        for (let i = 0; i < list.length; i++) {
            const ratio = cellWidth / (list[i].widthCover || list[i].widthSmall || list[i].width);
            let height = Math.floor((list[i].heightCover || list[i].heightSmall || list[i].height) * ratio);
            let minIndex = i;
            if (i >= 6) {
                const minValue = Math.min(...liHeightList);
                minIndex = liHeightList.indexOf(minValue);
            }
            if (minIndex < 0) {
                minIndex = 0
            }

            liHeightList[minIndex] += height;

            let largeHeight = height * 600 / 238
            // console.debug(liHeightList, Math.min(...liHeightList),minIndex)
            liContentList[minIndex].push({
                ...list[i],
                height,
                largeHeight
            });


        }
        setLiContent(liContentList);
    };

    const onChange = v => {
        const _id = v.insId ? v.insId : v.id
        if (!setSelectedIds || disabled) return;
        let index = selectedIds.indexOf(_id);

        if (index != -1) {
            if (onSelect) onSelect(v, false); // 取消选中
            selectedIds.splice(index, 1);
            setSelectedIds([...selectedIds]);
        } else {
            if (onSelect) onSelect(v, true); // 选中
            console.debug(v)
            setSelectedIds([...selectedIds, _id]);
        }
    };

    return (<
            div className='waterfall_container' >
        <
            ul ref={
                refUl
            } > {
                liContent.map((item, index) => {
                    return (<
                                li key={
                            `v.id-${index}`
                        } > {
                            item.map(v => (
                                // <Popover key={v.id + 'popover'+index} placement={index<=2?'rightTop':'leftTop'} overlayStyle={{width:650, height: v.largeHeight}} content={
                                //     <SimpleImg key={v.id + `popover_${index}`} className='waterFall_item_img_wrap' 
                                //         src={v.imgOrigins + '?x-oss-process=image/auto-orient,1/resize,m_lfit,w_600,limit_0/format,webp'}/>} 
                                //     >
                                <
                                            div className='waterfall_item'
                                    key={
                                        v.insId ? v.insId : v.id
                                    }
                                    style={
                                        {
                                            width: cellWidth,
                                            height: v.height
                                        }
                                    }
                                    onClick={
                                        () => onChange(v)
                                    }
                                    onContextMenu={
                                        (e) => {
                                            e.preventDefault()
                                            if (setImgUrl) setImgUrl(v.ossUrl ? v.ossUrl : v.cover)
                                            if (setShowBigImg) setShowBigImg(true)
                                        }
                                    }
                                >

                                    <
                                        SimpleImg className='waterFall_item_img_wrap'
                                        src={
                                            v.ossUrl ? v.ossUrl + imgSuffix(cellWidth, v.height) : v.cover + imgSuffix(cellWidth, v.height)
                                        }
                                    />

                                    <
                                        div className={
                                            `select_icon ${selectedIds.includes(v.insId ? v.insId : v.id) && 'selected'}`
                                        } >
                                        <
                                            div className='triangle' /> {
                                            /* <Icon type='check' className='check' /> */
                                        } <
                                            /div> {
                                            displayRender && displayRender(v)
                                        } <
                                        /div>
                                        // </Popover>
                                    ))
                            } <
                            /li>
                                    )
                })
        } <
        /ul> < /
        div >
                                    )
}